export default {
   'features': 'الميزات',
   'downloads': 'التنزيلات',
   'roadmap': 'خريطة الطريق',
   'price': 'السعر',
   'donate': 'تبرع',
   'feedback': 'ملاحظات',
   'panel': 'لوحة التحكم',
};
